import React, { Component } from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

const styles = (theme) => ({
  dialogRoot: {},
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
  },
  dialogTitleContent: {
    textAlign: 'center',
    fontSize: '19.5px',
    fontWeight: 'bold',
    color: '#377ac6',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    borderBottom: '2px solid #377ac6',
  },
  closeBtn: {
    right: '12px',
    top: '20px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      right: 0,
      top: 0,
    },
    '& svg': {
      fontSize: '1.5em',
    },
  },
  dialogContent: {
    marginBottom: '10px',
  },
  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    // padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  vodIframe: {
    height: '40vw',
    [theme.breakpoints.down('lg')]: {
      height: '33vw',
    },
    [theme.breakpoints.down('md')]: {
      height: '50vw',
    },
  },
});

class PgmVodDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vodId: this.props.vodId,
    };
  }

  render() {
    const { classes, open, onClose } = this.props;
    // eslint-disable-next-line
    const testVideo = 'https://s3.ap-northeast-2.amazonaws.com/hemlibra.web-symposium.co.kr/static/media/test1.8ab528fa.mp4';
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          onClose={onClose}
          aria-labelledby="pgm-vod-dialog"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          {/* <DialogTitle className={classes.dialogTitle}>
            <div className={classes.dialogTitleContent}>
              <span>Welcome Message</span>
            </div>
          </DialogTitle> */}
          <DialogContent className={classes.dialogContent} style={{ padding: 0, margin: 0 }}>
            <IconButton onClick={onClose} className={classes.closeBtn} style={{ position: 'absolute', zIndex: 999 }}>
              <CloseIcon style={{ color: '#000' }} />
            </IconButton>
            <div>
              <iframe
                title="program_vod"
                id="player"
                style={{ width: '100%' }}
                src={`https://player.vimeo.com/video/${this.props.vodId}`}
                width="800"
                frameBorder="0"
                allow="autoplay; fullscreen"
                className={classes.vodIframe}
                allowFullScreen
              />
            </div>
          </DialogContent>
          {/* <DialogActions className={classes.dialogActions}>
            <div style={{ borderTop: '1px solid rgba(1,1,1,0.2)', margin: '0 15px', paddingTop: '10px' }}>
              <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                닫기
              </Button>
            </div>
          </DialogActions> */}
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(PgmVodDialog);
